import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Popup from "../../common/Popup";
import {DKLabel, DKButton, DKInput, showToast, TOAST_TYPE,showLoader,removeLoader} from "deskera-ui-library"
import { INPUT_TYPE } from "../../../constants/Constant";
import Utility from "../../../utility/Utility";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import moment from "moment";
import Table from "../../../services/table";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import { TABLES } from "../../../managers/TableManger";

const AddContractorPayrun = (props) => {

  const [defaultValues, setDefaultValues] = useState([]);
  const [users, setUsers] = useState(props.inputData.users)
  const [contractors, setContractors] = useState([]);
  const [isAllEmployees, setAllEmployees] = useState(false);
  const [isEdit, setEdit] = useState(!Utility.isEmpty(props.recordId));

    useEffect(() => {
      // RouteManager.setPresenter({ props });
      editContractorValues();
      if(isEdit) {
        setFormFieldValues()
      }
    },[]);

    // useEffect(() => {
    //   if(defaultValues) {
    //     setDefaultValues(defaultValues)
    //   }
    // },[defaultValues])

    const editContractorValues = () => {
      let data = users && users.map((x) => {
        let firstName = x.firstName ? x.firstName: ""
        let lastName = x.lastName ? x.lastName : ""
        return `${firstName} ${lastName}`
      });
      setContractors(data);
    }

    const setFormFieldValues = () => {
      let formValues = []
      let values = props.defaultValues;
      let payDate = values.payDate
            ? moment(values.payDate, "MM/DD/YYYY").toDate()
            : moment().endOf('month').toDate();
      let isAppliableToAll = values.isForAllUsers ? values.isForAllUsers : false;
      if(!isAppliableToAll && values.employees && values.employees.length > 0) {
        let selectedUser = values.employees.map(r => users.findIndex(op => op.userId == r));
        formValues["USERS"] = selectedUser;
      }
      formValues["PAYDATE"] = payDate
      formValues["ALL_EMPLOYEE"] = isAppliableToAll ? "Yes" : "No";
      setDefaultValues(formValues);
      setAllEmployees(!isAppliableToAll);
    }

    const onClose = () => {
        if (props.onClose) props.onClose();
        removePopUp();
    };

    const removePopUp = () => {
        ReactDOM.unmountComponentAtNode(document.getElementById(props.id));
        document.getElementById(props.id)?.remove();
    }

    const addContractorPayrun = () => {
      if(Utility.isEmpty(defaultValues["PAYDATE"])) {
        showToast("Please fill mandatory details", TOAST_TYPE.FAILURE);
        return;
      } else if(Utility.isEmpty(defaultValues["ALL_EMPLOYEE"])) {
        showToast("Please fill mandatory details", TOAST_TYPE.FAILURE);
        return;
      } else if(!Utility.isEmpty(defaultValues["ALL_EMPLOYEE"]) && defaultValues["ALL_EMPLOYEE"] === "No" && Utility.isEmpty(defaultValues["USERS"])){
        showToast("Please fill mandatory details", TOAST_TYPE.FAILURE);
        return;
      }

      let paramters = getPayrunObject();
      showLoader(`Payroll is being ${isEdit ? "updated" : "added"}...`);
        (!isEdit
            ? Table.savePayroll(paramters)
            : Table.editPayroll({ ...paramters, ...{_id: props.recordId}})
        ).finally(() => removeLoader())
            .then(
                (res:any) => {
                    showToast(
                        `${isEdit ? "Payroll Updated" : "Payroll Added"} Successfully`,
                        TOAST_TYPE.SUCCESS
                    );
                    RouteManager.navigateToPage(
                        PAGE_ROUTES.PROCESS_PAYROLL,
                        `module=${TABLES.PAYROLL}&origin=${PAGE_ROUTES.PAYROLL_GRID}&id=${res._id}&step=0&isContractor=true`)
                    removePopUp();
                },
                (err) => {
                    if(err === "Empty Payrun\n"){
                        showToast(
                            "Payrun criteria is not matching for any employee payroll.",
                            TOAST_TYPE.FAILURE
                        );
                    } else {
                        showToast(
                            "Some Unknown Error Occurred at Server.Please Try Again!",
                            TOAST_TYPE.FAILURE
                        );
                    }
                }
            );

    }

    const getPayrunObject = () => {
      let selectedDate = moment(defaultValues["PAYDATE"]).format("MM/DD/YYYY");
      let selectedUsers = defaultValues["ALL_EMPLOYEE"] === "No" ? getSelectedUsers() : [];
      let object = {
        countryCode : TenantService.get(TENANT.COUNTRY_CODE),
        isForAllUsers: defaultValues["ALL_EMPLOYEE"] === "Yes",
        isForContractors: true,
        employees:selectedUsers,
        payDay: selectedDate,
        payDate: selectedDate,
        workPeriod:{
          from:"",
          to: selectedDate
        }
      }
      return object;
    }

    const getSelectedUsers = () => {
      const selectedIndexes = defaultValues["USERS"];
      const selectedUser = [];
      if(!Utility.isEmpty(selectedIndexes)) {
        selectedIndexes.forEach(element => {
          if(users[element]) {
            selectedUser.push(users[element].userId)
          }

        });
      }
      return selectedUser;
    }

    const onChange = (value, field) => {
      defaultValues[field] = value;
      switch(field) {
        case "ALL_EMPLOYEE" :
          let isAllEmployees = defaultValues[field] === "No";
          setAllEmployees(isAllEmployees)
          break;
      }
    }

    return (
      <>
        <Popup popupClass={"popup-overflow"}>
          <div>
            <div className="parent-width" style={{ display: "flex" }}>
              <DKLabel text="Pay Contractor" className="fw-m fs-l fw-m align-self-center width-80" />
                <div className="d-flex  ">
                  <DKButton title="Cancel" className="g-gray1 border-m" onClick={(event) => {onClose();}} />
                  <DKButton
                      title="Save"
                      className="border-m ml-r bg-app text-white"
                      onClick={() => addContractorPayrun()}
                  />

                </div>
            </div>
            <div className="m-v-l">
              <DKInput
                autoFocus={true}
                className={"mb-xl"}
                title={`Pay Date`}
                placeholder={`Pay Date`}
                value={defaultValues["PAYDATE"]}
                type={"date"}
                errorMsg={"Enter a valid Pay Date"}
                labelClassName=" text-align-left "
                onChange={(value) => {
                  onChange(value, "PAYDATE");
                }}
                direction={"HORIZONTAL"}
                required={true}
                dateFormat={props.dateFormat}
                readOnly={false}
                canValidate={true}
              />
            </div>
            <div className="m-v-l">
                <DKInput
                autoFocus={true}
                className={"mb-s"}
                title={`Applicable To All`}
                placeholder={`Applicable To All`}
                value={defaultValues["ALL_EMPLOYEE"]}
                type={"dropdown"}
                errorMsg={"Enter a valid value"}
                labelClassName=" text-align-left "
                onChange={(value) => {
                  onChange(value, "ALL_EMPLOYEE");
                }}
                direction={"HORIZONTAL"}
                required={true}
                readOnly={false}
                canValidate={true}
                formatter={(obj) => {
                  return obj;
                }}
                dropdownConfig={{
                    className: "",
                    style: {},
                    allowSearch: true,
                    searchableKey: undefined,
                    data: ["Yes", "No"],
                    renderer: (index, obj) => {
                      return (
                        <DKLabel
                          className="bg-chip-blue p-h-xs border-radius-s"
                          text={obj}
                        />
                      );
                    },
                    onSelect: (index, value) => {
                      onChange(value, "ALL_EMPLOYEE")
                    },
                  }}
                />
            </div>
            {isAllEmployees && (
              <div className="m-v-l">
                <DKInput
                autoFocus={true}
                className={"mb-s"}
                title={`Users`}
                placeholder={`Users`}
                value={defaultValues["USERS"]}
                options={contractors}
                type={INPUT_TYPE.MULTI_SELECT}
                errorMsg={"Enter a valid value"}
                labelClassName=" text-align-left "
                onChange={(value) => {
                  onChange(value, "USERS");
                }}
                direction={"HORIZONTAL"}
                required={true}
                readOnly={false}
                canValidate={true}
                />
            </div>
            )}
          </div>
        </Popup>
      </>
    );

}
export const showUpdateContractorPayrollPopup = (
    config: { tableName: string; displayName: string; defaultValues?: any; recordId?: string; isCustomForm?: any; inputData?: any },
    onSave: () => void,
    onClose: () => void
) => {
    const id = `add-new-rec-popup-${new Date().getTime()}`;
    let div = document.createElement("div");
    div.className = "app-font";
    div.setAttribute("id", id);
    ReactDOM.render(
        <AddContractorPayrun
            id={id}
            onSave={onSave}
            onClose={onClose}
            defaultValues={config.defaultValues}
            recordId={config.recordId}
            displayName={config.displayName}
            isCustomForm={config.isCustomForm}
            inputData={config.inputData}
        />,
        document.body.appendChild(div)
    );
};

export default AddContractorPayrun;